import type { IconData } from '@stacksjs/iconify-core'

export const refrigeratorFlat: IconData = {
  "body": "<g fill=\"none\"><path fill=\"#8fbffa\" d=\"M42.5 24c0-8.43-.276-13.57-.543-16.568c-.26-2.922-2.444-5.141-5.37-5.43C34.027 1.747 29.992 1.5 24 1.5s-10.026.248-12.588.501c-2.925.29-5.109 2.509-5.369 5.43c-.266 3-.543 8.139-.543 16.569s.277 13.57.543 16.569c.26 2.921 2.444 5.14 5.37 5.43c2.56.253 6.595.501 12.587.501s10.026-.248 12.587-.501c2.926-.29 5.11-2.509 5.37-5.43c.267-3 .543-8.139.543-16.569\"/><path fill=\"#2859c5\" d=\"M15 30a2 2 0 0 0-2 2v4a2 2 0 1 0 4 0v-4a2 2 0 0 0-2-2m0-20a2 2 0 0 0-2 2v4a2 2 0 1 0 4 0v-4a2 2 0 0 0-2-2m27.497 12.5a366 366 0 0 1 0 3H5.503a370 370 0 0 1 0-3z\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default refrigeratorFlat
